import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useNavigate } from 'react-router-dom';
//import { makeStyles } from '@mui/styles';
import {
  Dialog, DialogTitle, Button, ButtonGroup, FormControl, TextField, Grid, 
} from '@mui/material';
import Box from '@mui/material/Box';
import { AppHelper } from '../AppHelper';
import LoadingButton from '@mui/lab/LoadingButton';
import Autocomplete from '@mui/material/Autocomplete';

export default function PopLinkTutor({
  onClose, open, tutors, model, tuiton
}) {
  const [loading, setLoading] = useState(false);
  const [isSa, setIsSa] = useState(false);
  const [oUser, setOUser] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [profileId, setProfileId] = useState('');
  const [authOK, setAuthOK] = React.useState(false);
  const [selectedTutor, setSelectedTutor] = useState();
  const [gradeList, setGradeList] = useState([]);

  const fetchIAM = async (oUser) => {
    var _res = await AppHelper.apiPost('api/account/iam', { token: oUser.token });
    if (!_res || !_res.status || !_res.data || !_res.data.isSa) {
      return;
    }
    setIsSa(true);
  }

  const tutorSelect = async (arg) => {
    setProfileId(arg.profileId);
    setSelectedTutor(arg);
  };

  const filteredTutors = tutors.filter(
      (x) =>
        x.accountType === "TEA" &&
        !x.centerId &&
        x.type === "Account"
  );
  useEffect(() => {
    var _user = AppHelper.userCacheGet();
    setAuthOK(_user != null);
    setOUser(_user);
    if (_user && _user.name) {
      fetchIAM(_user);
    }
  }, []);

  useEffect(() => {
    if (open) {
      setProfileId("");
      setGradeList([
        {v:'P1', a:2}, {v:'P2', a:2}, {v:'P3', a:2},
        {v:'P4', a:2}, {v:'P5', a:2}, {v:'P6', a:2},
        {v:'S1', a:2}, {v:'S2', a:2}, {v:'S3', a:2},
        {v:'S4', a:2}, {v:'S4E', a:2}, {v:'S5', a:2},
      ]);
    }
  }, [open]);

  useEffect(() => {
  }, []);

  const handleSubmit = async () => {
    if (profileId == "") {
      alert("Tutor is required");
      return;
    }
    setLoading(true);

    var _res = await AppHelper.apiPost('api/profile/tutor/link', { token: oUser.token, profileId: profileId, centerId: tuiton });
    if (!_res || !_res.status) {
      setLoading(false);
      return;
    }
    for(var i=0;i<gradeList.length;i++){
      var _resAccess = await AppHelper.apiPost("api/access/update", {
        token: oUser.token,
        profileId: profileId,
        grade: gradeList[i].v, 
        access: gradeList[i].a
      });
    }
    alert("Link success");
    onClose(true);
    setSelectedTutor(); // To not show the Tutor that is linked (will not in tutor list) to be shown again in the pop-up. 
    setLoading(false);
  };
  const clickAccess = async(argGrade, argValue)=>{
    var _grades = [...gradeList];
    var _grade = _grades.find(r=>r.v==argGrade.v);
    _grade.a = argValue;
    setGradeList(_grades);
  };
  const handleClose = () => { onClose(false) };

  return (
    <>
      <Dialog onClose={handleClose} open={open} fullWidth>
        <DialogTitle>{"LINK TUTOR"}</DialogTitle>
        <Box pl={2} pr={2} pb={2} alignItems="flex-start">

          <Grid>
            <Grid item xs={12} sm={6}>
              <Box m={.5} >

                <Grid item mt={1.5}>
                  {tutors && (
                  <FormControl fullWidth>
                    <Autocomplete
                      options={filteredTutors}
                      value={selectedTutor}
                      onChange={(event, newValue) => {
                        tutorSelect(newValue ? newValue : "");
                      }}
                      getOptionLabel={(option) =>
                        `${option.name} (${option.email})`
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="TUTOR" />
                      )}
                    />
                  </FormControl>
                )}
                </Grid>

              </Box>
            </Grid>
            <Grid container m={1}>
              {gradeList.map((gg, iGG) => (
                <React.Fragment key={'popAccessGrade_'+iGG}>
                <Grid item xs={4} style={{textAlign:'center'}}>
                  {gg.v}
                </Grid>
                <Grid item xs={8}>
                  <ButtonGroup aria-label="Basic button group" style={{marginTop:'2px'}}>
                    <Button
                      variant={gg.a === 0 ? 'contained' : 'outlined'}
                      sx={{
                      backgroundColor: gg.a === 0 ? '#808080' : 'transparent', // Gray for contained
                      color: gg.a === 0 ? '#fff' : 'inherit',                 // White text for gray
                      borderColor: gg.a === 0 ? 'transparent' : 'primary.main', // Border for outlined
                      '&:hover': {
                        backgroundColor: gg.a === 0 ? '#696969' : 'transparent', // Darker gray on hover
                      },
                      }}
                      onClick={() => clickAccess(gg, 0)}
                    >
                      NA
                    </Button>

                    <Button variant={gg.a==1?'contained':'outlined'} onClick={()=>clickAccess(gg, 1)}>VIEW</Button>
            
                    <Button
                      variant={gg.a === 2 ? 'contained' : 'outlined'}
                      sx={{
                      backgroundColor: gg.a === 2 ? 'rgba(19, 130, 117, 1)' : 'transparent', // Teal for contained
                      color: gg.a === 2 ? '#fff' : 'inherit',                // White text for teal
                      borderColor: gg.a === 2 ? 'transparent' : 'primary.main', // Border for outlined
                      '&:hover': {
                        backgroundColor: gg.a === 2 ? '#138275' : 'transparent', // Darker teal on hover
                      },
                      }}
                      onClick={() => clickAccess(gg, 2)}
                    >
                      MANAGE
                    </Button>
                  </ButtonGroup>
                </Grid>
                </React.Fragment>
              ))}
            </Grid>
            <Grid container pt={.5}>
              <Grid item xs={6}>

              </Grid>
              <Grid item xs={6}>
                <Box display="flex" justifyContent="flex-end">
                  <LoadingButton
                    onClick={handleSubmit}
                    loading={isSubmitting}
                    variant="contained"
                  >
                    <span>LINK</span>
                  </LoadingButton>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </>
  );
}
